import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  alertRuleAccordionDetails: {
    '& *': {
      fontWeight: 'normal !important'
    }
  },
  alertRulePanelAccordion: {
    background: 'none',
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    },
    marginLeft: '-1rem!important',
    marginRight: '-1rem!important'
  },
  alertRulePanelAccordionSummary: {
    backgroundColor: theme.vars.palette.background.elevation1,
    boxShadow: 'none',
    minHeight: '3rem', // fixed height
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    borderTop: `1px solid ${theme.vars.palette.divider}`,
    marginTop: '-1px',
    fontSize: '1rem',
    fontWeight: 600,
    width: '100%',
    '&.Mui-expanded': {
      minHeight: '3rem' // stop growing when expanded
    },
    '& .MuiAccordionSummary-content': {
      margin: 0 // reset margin
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0 // stop shifting
    }
  },
  alertRulesMarkdown: {
    '& *': {
      marginTop: 0,
      marginBottom: 0,
      fontWeight: 'normal'
    }
  }
}));

export default useStyles;
